// extracted by mini-css-extract-plugin
module.exports = {"item":"menu-module_item_2L_Bn","menu":"menu-module_menu_1uJZa"};